const LinkedinIcon = ({ size = 16, color = "currentColor" }) => (
  <svg
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
  >
    <path d="M14,19 L10,19 L10,12.001 C10,10.081 9.153,9.01 7.634,9.01 C5.981,9.01 5,10.126 5,12.001 L5,19 L1,19 L1,6 L5,6 L5,7.462 C5,7.462 6.255,5.26 9.083,5.26 C11.912,5.26 14,6.986 14,10.558 L14,19 L14,19 Z M-3.558,3.921 C-4.907,3.921 -6,2.819 -6,1.46 C-6,0.102 -4.907,-1 -3.558,-1 C-2.21,-1 -1.117,0.102 -1.117,1.46 C-1.116,2.819 -2.21,3.921 -3.558,3.921 L-3.558,3.921 Z M-6,19 L-1,19 L-1,6 L-6,6 L-6,19 Z" transform="translate(6,1)" />
  </svg>
);

export default LinkedinIcon;